import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-website-development',
  templateUrl: './website-development.component.html',
  styleUrls: ['./website-development.component.scss']
})
export class WebsiteDevelopment implements OnInit {

  constructor(
    private titleService: Title,
    private meta: Meta,
  ) { }

  ngOnInit() {
    this.titleService.setTitle('Kaims IT Services | Custom Software Development | ERP Development | Website Development Company in Ahmedabad - India');
    this.meta.updateTag({ name: "description", content: 'Partner with Kaims IT Services for your ERP, CRM, Application Management and Cloud Solutions needs by hiring our CRM and .NET Experts in India' });
    this.meta.updateTag({ name: "keywords", content: 'Web Development Company India, Mobile App Development Company India and India, ERP and CRM Service Provider, Kaims IT Services' });
    this.meta.updateTag({ name: "author", content: 'Kaims IT Services' });
  }

}
